/**
 * LW24 XXL Logo-Lampe Funnel - Core JS
 *
 * Klon des Logo-Funnels (lw-funnel.js), angepasst auf das XXL-Muster-Produkt.
 *
 * Wichtigste Unterschiede zum Logo-Funnel:
 *   - 7 Steps: form, einsatz, upload, lichtfarbe, groesse, rueckseite, review
 *   - KEINE Preismatrix mehr. Der Funnel laeuft auf dem
 *     "XXL Logo-Lampe Muster"-Produkt mit EINER Variante zu 50 Euro.
 *     findVariantForCart() nimmt IMMER die erste verfuegbare Variante.
 *   - Neue States: einsatz, lichtfarbe, size (Wunsch-Groesse),
 *     rueckseite + rueckseite_text
 *   - Cloudinary-Ordner xxl-logo statt logo
 *   - KI-Vorschau wird beim Verlassen des upload-Steps angestossen
 *     (Form liegt davor, Upload ist da).
 *
 * Cart-Properties:
 *   Sichtbar: "Form", "Einsatzort", "Lichtfarbe", "Wunsch-Groesse",
 *             "Rueckseite", "Logo-Vorschau", "Lampen-Vorschau"
 *   Hidden:   _Vorschau-Modus, _Funnel-Session, _Funnel-Version,
 *             _Funnel-Typ=xxl-logo, _Upload-Zustimmung
 */

(function () {
  'use strict';

  // 7 Steps in fester Reihenfolge
  const STEPS = ['upload', 'form', 'groesse', 'lichtfarbe', 'einsatz', 'rueckseite', 'review'];
  const STORAGE_KEY = 'lw_funnel_xxl_v1';
  const FUNNEL_VERSION = 'v1.0-xxl';

  // ---------- Daten aus Liquid holen ----------
  let DATA = {};
  try {
    const el = document.getElementById('lw-funnel-data');
    DATA = JSON.parse(el.textContent);
  } catch (e) {
    console.error('[lw-funnel-xxl] Konnte lw-funnel-data nicht parsen:', e);
    return;
  }

  const root = document.getElementById('lw-funnel');
  if (!root) return;

  // ---------- State ----------
  const state = {
    load() {
      try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}; }
      catch (e) { return {}; }
    },
    save(d) { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(d)); },
    get(k) { return this.load()[k]; },
    set(k, v) { const d = this.load(); d[k] = v; this.save(d); },
    unset(k) { const d = this.load(); delete d[k]; this.save(d); },
    clear() { sessionStorage.removeItem(STORAGE_KEY); }
  };

  function ensureDefaults() {
    const d = state.load();
    if (!d.shape) d.shape = null;
    if (typeof d.einsatz === 'undefined') d.einsatz = null;
    if (!d.upload) d.upload = null;
    if (typeof d.invert === 'undefined') d.invert = false;
    if (typeof d.lichtfarbe === 'undefined') d.lichtfarbe = null;
    if (!d.size) d.size = null;
    if (typeof d.size_custom === 'undefined') d.size_custom = '';
    if (typeof d.rueckseite === 'undefined') d.rueckseite = null;
    if (typeof d.rueckseite_text === 'undefined') d.rueckseite_text = '';
    if (typeof d.preview === 'undefined') d.preview = null;  // {status,sig,url}
    if (!d.step) d.step = getStepFromURL() || STEPS[0];
    state.save(d);
  }

  // ---------- URL-Sync ----------
  function getStepFromURL() {
    const params = new URLSearchParams(location.search);
    const s = params.get('step');
    return STEPS.includes(s) ? s : null;
  }

  function syncURLToStep(name) {
    const idx = STEPS.indexOf(name);
    if (idx < 0) return;
    const params = new URLSearchParams(location.search);
    params.set('step', name);
    const newUrl = location.pathname + '?' + params.toString();
    history.replaceState({ step: name }, '', newUrl);
  }

  // ---------- Variant-Matching (vereinfacht: immer das 50-Euro-Muster) ----------
  // Es gibt keine Groessen-/Farb-Matrix mehr. Der Funnel laeuft auf einem
  // Produkt mit EINER Variante (50 Euro). Wir nehmen immer die erste
  // verfuegbare Variante (sonst die erste ueberhaupt).
  function findVariantForCart() {
    const variants = (DATA.product && DATA.product.variants) || [];
    const available = variants.find(v => v.available);
    if (available) return available;
    return variants[0] || null;
  }

  // ---------- Pricing ----------
  const FALLBACK_PRICE_CENTS = 5000; // 50 Euro Muster

  function calcPriceCents() {
    const v = findVariantForCart();
    if (v && v.price) return v.price;
    return FALLBACK_PRICE_CENTS;
  }

  function fmtPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // ---------- Progress & Steps ----------
  function currentStepIdx() {
    const s = state.get('step') || STEPS[0];
    return Math.max(0, STEPS.indexOf(s));
  }

  function updateProgress() {
    const idx = currentStepIdx();
    root.querySelectorAll('[data-progress] .lw-progress__dot').forEach((dot, i) => {
      dot.classList.remove('is-active', 'is-done');
      if (i < idx) dot.classList.add('is-done');
      if (i === idx) dot.classList.add('is-active');
    });
  }

  function showStep(name) {
    if (!STEPS.includes(name)) return;
    state.set('step', name);
    syncURLToStep(name);
    root.querySelectorAll('.lw-step').forEach(el => {
      el.hidden = el.dataset.step !== name;
    });
    updateProgress();
    updateActionBar();
    restoreUI();
    if (name === 'review') renderReview();
    scrollFunnelTop();
  }

  function scrollFunnelTop() {
    requestAnimationFrame(function () {
      try { window.scrollTo(0, 0); } catch (e) {}
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      var sc = root.parentElement;
      while (sc) {
        if (sc.scrollHeight > sc.clientHeight + 4) sc.scrollTop = 0;
        sc = sc.parentElement;
      }
    });
  }

  function goNext() {
    if (!validateCurrentStep()) return;
    const idx = currentStepIdx();
    // KI-Vorschau anstossen beim Verlassen des form-Steps: jetzt liegen Logo (Step 1) + Form vor,
    // damit der Render im Hintergrund laeuft, waehrend der Kunde Groesse/Lichtfarbe/etc. waehlt.
    if (state.get('step') === 'form') startPreview();
    if (idx < STEPS.length - 1) showStep(STEPS[idx + 1]);
    else submitCart();
  }

  function goBack() {
    const idx = currentStepIdx();
    if (idx > 0) showStep(STEPS[idx - 1]);
  }

  function validateCurrentStep() {
    const d = state.load();
    if (d.step === 'form' && !d.shape) { showToast('Bitte wähle zuerst eine Form'); return false; }
    if (d.step === 'einsatz' && !d.einsatz) { showToast('Bitte wähle drinnen oder draußen'); return false; }
    if (d.step === 'upload' && !d.upload) { showToast('Bitte lade dein Logo hoch'); return false; }
    if (d.step === 'upload' && !d.upload_consent) { showToast('Bitte bestätige die Nutzungsrechte'); return false; }
    if (d.step === 'lichtfarbe' && !d.lichtfarbe) { showToast('Bitte wähle eine Lichtfarbe'); return false; }
    if (d.step === 'groesse' && !d.size) { showToast('Bitte wähle eine Wunsch-Größe'); return false; }
    if (d.step === 'groesse' && d.size === 'custom' && !(d.size_custom || '').trim()) {
      showToast('Bitte trag dein Wunschmaß ein'); return false;
    }
    if (d.step === 'rueckseite' && !d.rueckseite) { showToast('Bitte wähle eine Rückseite'); return false; }
    if (d.step === 'rueckseite' && d.rueckseite === 'freitext' && !(d.rueckseite_text || '').trim()) {
      showToast('Bitte beschreibe deinen Rückseiten-Wunsch'); return false;
    }
    return true;
  }

  function updateActionBar() {
    const d = state.load();
    const idx = currentStepIdx();
    const isFirst = idx === 0;
    const isLast = idx === STEPS.length - 1;

    const backBtn = document.querySelector('.lw-actionbar [data-action="back"]');
    if (backBtn) backBtn.disabled = isFirst;

    const nextBtn = document.querySelector('.lw-actionbar [data-action="next"]');
    const nextLabel = document.querySelector('.lw-actionbar [data-next-label]');

    let canProceed = true;
    if (d.step === 'form' && !d.shape) canProceed = false;
    if (d.step === 'einsatz' && !d.einsatz) canProceed = false;
    if (d.step === 'upload' && (!d.upload || !d.upload_consent)) canProceed = false;
    if (d.step === 'lichtfarbe' && !d.lichtfarbe) canProceed = false;
    if (d.step === 'groesse' && !d.size) canProceed = false;
    if (d.step === 'groesse' && d.size === 'custom' && !(d.size_custom || '').trim()) canProceed = false;
    if (d.step === 'rueckseite' && !d.rueckseite) canProceed = false;
    if (d.step === 'rueckseite' && d.rueckseite === 'freitext' && !(d.rueckseite_text || '').trim()) canProceed = false;
    // In den Warenkorb erst wenn die KI-Lampen-Vorschau fertig ist.
    const previewPending = d.step === 'review' && d.preview && d.preview.status === 'pending';
    if (previewPending) canProceed = false;

    if (nextBtn) nextBtn.disabled = !canProceed;

    const priceEl = document.querySelector('.lw-actionbar [data-live-price]');
    if (priceEl) priceEl.textContent = fmtPrice(calcPriceCents());

    const hardFallback = d.step === 'review' && d.preview && d.preview.status === 'error' && (d.preview.errorCount || 0) >= 2;
    if (nextLabel) {
      nextLabel.textContent = previewPending ? 'Vorschau lädt …'
        : (hardFallback ? 'Trotzdem ins Studio'
          : (isLast ? 'Muster sichern - 50 €' : 'Weiter'));
    }
  }

  function restoreUI() {
    const d = state.load();

    // Form
    root.querySelectorAll('.lw-shape').forEach(el => {
      el.setAttribute('aria-selected', el.dataset.shape === d.shape ? 'true' : 'false');
    });

    // Einsatzort
    root.querySelectorAll('[data-einsatz]').forEach(el => {
      el.setAttribute('aria-selected', el.dataset.einsatz === d.einsatz ? 'true' : 'false');
    });

    // Upload
    root.querySelectorAll('[data-upload-state]').forEach(el => {
      const target = d.upload ? 'success' : 'empty';
      el.style.display = el.dataset.uploadState === target ? '' : 'none';
    });
    if (d.upload) {
      const fn = root.querySelector('[data-upload-filename]');
      const fs = root.querySelector('[data-upload-filesize]');
      if (fn) fn.textContent = d.upload.name;
      if (fs) fs.textContent = d.upload.sizeMB + ' MB · bereit zum Druck';
      const consent = root.querySelector('[data-upload-consent]');
      if (consent) consent.checked = !!d.upload_consent;
    }

    // Invert-Auswahl
    root.querySelectorAll('[data-invert]').forEach(el => {
      const isInv = el.dataset.invert === 'invertiert';
      el.setAttribute('aria-selected', (isInv === !!d.invert) ? 'true' : 'false');
    });

    // Lichtfarbe
    root.querySelectorAll('[data-lichtfarbe]').forEach(el => {
      el.setAttribute('aria-selected', el.dataset.lichtfarbe === d.lichtfarbe ? 'true' : 'false');
    });

    // Groesse (Wunsch-Groesse)
    root.querySelectorAll('.lw-size').forEach(el => {
      el.setAttribute('aria-selected', el.dataset.size === d.size ? 'true' : 'false');
    });
    const sizeText = root.querySelector('[data-size-text]');
    const sizeTextWrap = root.querySelector('[data-size-textwrap]');
    if (sizeText) sizeText.value = d.size_custom || '';
    if (sizeTextWrap) sizeTextWrap.style.display = (d.size === 'custom') ? '' : 'none';

    // Rueckseite
    root.querySelectorAll('[data-rueckseite]').forEach(el => {
      el.setAttribute('aria-selected', el.dataset.rueckseite === d.rueckseite ? 'true' : 'false');
    });
    const rsText = root.querySelector('[data-rueckseite-text]');
    const rsTextWrap = root.querySelector('[data-rueckseite-textwrap]');
    if (rsText) rsText.value = d.rueckseite_text || '';
    if (rsTextWrap) rsTextWrap.style.display = (d.rueckseite === 'freitext') ? '' : 'none';
  }

  // ---------- KI-Lampen-Vorschau (n8n-Webhook) ----------
  function previewSig(d) {
    return [d.shape || 'eckig', d.invert ? 'inverted' : 'standard',
            (d.upload && d.upload.public_id) || ''].join('|');
  }

  function startPreview() {
    const d = state.load();
    if (!d.upload || !d.upload.url) return;
    const webhook = DATA.preview_webhook;
    if (!webhook) { console.warn('[lw-funnel-xxl] preview_webhook fehlt - Vorschau übersprungen'); return; }

    const sig = previewSig(d);
    if (d.preview && d.preview.sig === sig && d.preview.status !== 'error') return;

    const sessionId = d.preview_session || ('lw-' + Math.random().toString(36).slice(2, 10));
    state.set('preview_session', sessionId);
    const prevErrCount = (d.preview && d.preview.errorCount) || 0;
    state.set('preview', { status: 'pending', sig: sig, url: null, errorCount: prevErrCount });

    // 16.06.2026 Auto-Retry (1x) + 90s-Timeout gegen fal-Latenzspitzen.
    var KI_FETCH_TIMEOUT_MS = 90000;
    var _kiBody = {
      logo_url: d.upload.url,
      shape: d.shape || 'eckig',
      mode: d.invert ? 'inverted' : 'standard',
      session_id: sessionId
    };
    function kiFetchOnce() {
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var to = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, KI_FETCH_TIMEOUT_MS) : null;
      return fetch(webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(_kiBody),
        signal: ctrl ? ctrl.signal : undefined
      })
      .then(function (r) { if (to) clearTimeout(to); return r.text(); })
      .then(function (t) { try { return JSON.parse(t); } catch (_) { return null; } })
      .catch(function (err) { if (to) clearTimeout(to); throw err; });
    }
    function kiFetchWithRetry() {
      return kiFetchOnce()
        .then(function (res) { if (!res || !res.preview_url) { return new Promise(function (rs) { setTimeout(rs, 1500); }).then(kiFetchOnce); } return res; })
        .catch(function () { return new Promise(function (rs) { setTimeout(rs, 1500); }).then(kiFetchOnce); });
    }

    kiFetchWithRetry()
    .then(res => {
      const cur = state.load();
      if (!cur.preview || cur.preview.sig !== sig) return; // veraltet
      if (res && res.preview_url) {
        state.set('preview', { status: 'done', sig: sig, url: res.preview_url, errorCount: prevErrCount });
      } else {
        state.set('preview', { status: 'error', sig: sig, url: null, errorCount: prevErrCount + 1 });
      }
      if (state.get('step') === 'review') { renderReview(); updateActionBar(); }
    })
    .catch(e => {
      console.error('[lw-funnel-xxl] Vorschau-Fehler:', e);
      const cur = state.load();
      if (cur.preview && cur.preview.sig === sig) {
        state.set('preview', { status: 'error', sig: sig, url: null, errorCount: prevErrCount + 1 });
        if (state.get('step') === 'review') { renderReview(); updateActionBar(); }
      }
    });
  }

  // ---------- Review ----------
  function injectReviewPreview(body) {
    if (!body) return;
    body.querySelectorAll('.lw-compare, .lw-review-preview').forEach(function (el) { el.remove(); });
    const d = state.load();
    if (!d.upload || !d.upload.url) return;

    const wrap = document.createElement('div');
    wrap.className = 'lw-compare';

    // ===== LINKE KARTE: hochgeladenes Logo =====
    const uploadDisplay = pngUrlFor(d.upload.url);
    const left = document.createElement('a');
    left.className = 'lw-compare__card';
    left.href = '#step-upload';
    left.setAttribute('data-compare-edit', '1');
    left.innerHTML =
      '<span class="lw-compare__cap">Dein Logo</span>' +
      '<img class="lw-compare__img" src="' + escapeAttr(uploadDisplay) + '" alt="Dein Logo" loading="lazy">' +
      '<span class="lw-compare__hint">Klick zum Anpassen</span>';
    wrap.appendChild(left);

    // ===== RECHTE KARTE: KI-3D-Render =====
    const p = d.preview;
    const right = document.createElement('div');
    right.className = 'lw-compare__card';
    if (p && p.status === 'done' && p.url) {
      right.innerHTML =
        '<span class="lw-compare__cap">Deine Lampe</span>' +
        '<a class="lw-compare__imglink" href="' + escapeAttr(p.url) + '" target="_blank" rel="noopener" title="Vorschau gross ansehen">' +
          '<img class="lw-compare__img" src="' + escapeAttr(p.url) + '" alt="Deine Lampe in 3D" loading="lazy">' +
        '</a>' +
        '<button class="lw-compare__dl" type="button" data-preview-download>' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>' +
          'Speichern' +
        '</button>';
    } else if (p && p.status === 'pending') {
      right.innerHTML =
        '<span class="lw-compare__cap">Deine Lampe</span>' +
        '<div class="lw-compare__loading">' +
          '<div class="lw-compare__ring" aria-hidden="true">' +
            '<svg viewBox="0 0 100 100">' +
              '<circle class="lw-compare__ring-bg" cx="50" cy="50" r="40"/>' +
              '<circle class="lw-compare__ring-fg" cx="50" cy="50" r="40" data-ring-fg></circle>' +
            '</svg>' +
            '<div class="lw-compare__ring-text" data-ring-text>45s</div>' +
          '</div>' +
          '<div class="lw-compare__loading-text">3D-Rendering läuft …</div>' +
          '<div class="lw-compare__loading-sub">Gleich siehst du deine fertige Lampe.</div>' +
        '</div>';
      const ringFg = right.querySelector('[data-ring-fg]');
      const ringTxt = right.querySelector('[data-ring-text]');
      if (ringFg && ringTxt) {
        right.dataset.startedAt = String(Date.now());
        const dashTotal = 251.3, totalMs = 45000;
        const tick = function () {
          const curKi = state.load().preview;
          if (!curKi || curKi.status !== 'pending') return;
          const elapsed = Date.now() - parseInt(right.dataset.startedAt, 10);
          const pct = Math.min(1, elapsed / totalMs);
          ringFg.style.strokeDashoffset = String(dashTotal * (1 - pct));
          const remain = Math.max(0, Math.ceil((totalMs - elapsed) / 1000));
          ringTxt.textContent = remain > 0 ? (remain + 's') : '…';
          if (elapsed < totalMs + 30000) setTimeout(tick, 250);
        };
        ringFg.style.strokeDashoffset = String(dashTotal);
        setTimeout(tick, 50);
      }
    } else if (p && p.status === 'error') {
      const errCount = (p.errorCount || 0);
      if (errCount >= 2) {
        const uploadBase = d.upload && d.upload.original_filename ? d.upload.original_filename : 'mein-logo';
        const mailto = 'mailto:support@lampenwerk24.de' +
          '?subject=' + encodeURIComponent('XXL Logo-Lampe handisch rendern - ' + uploadBase) +
          '&body=' + encodeURIComponent('Hi LW24-Team,\n\nmein Logo (' + uploadBase + ') lässt sich nicht automatisch rendern. Bitte rendert mir die Lampe handisch.\n\nLogo-URL: ' + (d.upload && d.upload.url || '-') + '\nForm: ' + (d.shape || '-') + '\nWunsch-Größe: ' + (d.size || '-') + '\n\nDanke!');
        right.innerHTML =
          '<span class="lw-compare__cap">Deine Lampe</span>' +
          '<div class="lw-compare__loading">' +
            '<div class="lw-compare__error-icon" aria-hidden="true">' +
              '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" style="stroke:var(--marke)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
            '</div>' +
            '<div class="lw-compare__loading-text" style="color:#111">Vorschau braucht Handarbeit</div>' +
            '<div class="lw-compare__loading-sub" style="color:#6b6f76">Mit sehr stilisierten Motiven kommt unser Auto-Renderer manchmal nicht klar. Wir bauen dir die Lampe trotzdem, schreib uns kurz, wir antworten am gleichen Tag.</div>' +
            '<a class="lw-compare__retry" href="' + escapeAttr(mailto) + '">Per Mail anfragen</a>' +
            '<button class="lw-compare__retry-soft" type="button" data-preview-retry>Trotzdem nochmal versuchen</button>' +
          '</div>';
      } else {
        right.innerHTML =
          '<span class="lw-compare__cap">Deine Lampe</span>' +
          '<div class="lw-compare__loading">' +
            '<div class="lw-compare__error-icon" aria-hidden="true">' +
              '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" style="stroke:var(--marke)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
            '</div>' +
            '<div class="lw-compare__loading-text" style="color:#111">3D-Vorschau hat nicht geklappt</div>' +
            '<div class="lw-compare__loading-sub" style="color:#6b6f76">Kleiner Fehler beim Rendern. Klick auf "Erneut versuchen", wenn es nochmal scheitert, hilft dir unser Team direkt weiter.</div>' +
            '<button class="lw-compare__retry" type="button" data-preview-retry>Erneut versuchen</button>' +
          '</div>';
      }
    } else {
      right.innerHTML =
        '<span class="lw-compare__cap">Deine Lampe</span>' +
        '<div class="lw-compare__loading">' +
          '<div class="lw-compare__loading-text" style="color:#6b6f76">3D-Vorschau wird gleich vorbereitet …</div>' +
        '</div>';
    }
    wrap.appendChild(right);

    body.insertBefore(wrap, body.firstChild);

    left.addEventListener('click', function (e) {
      e.preventDefault();
      showStep('upload');
    });

    const dlBtn = right.querySelector('[data-preview-download]');
    if (dlBtn && p && p.url) {
      dlBtn.addEventListener('click', function () { downloadPreview(p.url); });
    }

    const retryBtn = right.querySelector('[data-preview-retry]');
    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        state.set('preview', null);
        startPreview();
        renderReview();
        updateActionBar();
      });
    }
  }

  function pngUrlFor(url) {
    if (!url || typeof url !== 'string') return url;
    if (url.indexOf('/upload/') === -1) return url;
    if (/\.(ai|eps|pdf)(\?|$)/i.test(url)) {
      return url.replace('/upload/', '/upload/f_png,w_800/');
    }
    return url;
  }

  function downloadPreview(url) {
    fetch(url, { mode: 'cors' })
      .then(function (r) { return r.blob(); })
      .then(function (blob) {
        const a = document.createElement('a');
        const obj = URL.createObjectURL(blob);
        a.href = obj;
        a.download = 'lampenwerk24-vorschau.jpg';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(obj); }, 4000);
      })
      .catch(function () {
        window.open(url, '_blank', 'noopener');
      });
  }

  function renderReview() {
    const d = state.load();
    const parts = [];

    const shapeLabels = { eckig: 'Eckig', rund: 'Rund', kontur: 'Nur Kontur' };
    parts.push(reviewRow('Form', shapeLabels[d.shape] || '-', 'form'));

    const einsatzLabels = {
      indoor: 'Drinnen · Material PETG',
      outdoor: 'Draußen · Material ASA, witterungsfest'
    };
    parts.push(reviewRow('Einsatzort', einsatzLabels[d.einsatz] || '-', 'einsatz'));

    parts.push(reviewRow('Logo', d.upload ? d.upload.name + ' · ' + d.upload.sizeMB + ' MB' : '-', 'upload'));
    parts.push(reviewRow('Darstellung', d.invert ? 'Invertiert' : 'Original', 'upload'));

    const lichtLabels = { kaltweiss: 'Kaltweiß · mit Fernbedienung', farbig: 'Farbig / RGB · mit Fernbedienung' };
    parts.push(reviewRow('Lichtfarbe', lichtLabels[d.lichtfarbe] || '-', 'lichtfarbe'));

    const sizeLabels = {
      '40': '40 cm', '50': '50 cm', '60': '60 cm', '70': '70 cm', '80': '80 cm',
      '90': '90 cm', '100': '100 cm', '200': '200 cm', '300': '300 cm und mehr'
    };
    const sizePrices = {
      '40': '199 €', '50': '249 €', '60': '299 €', '70': '369 €', '80': '449 €',
      '90': '549 €', '100': '699 €', '200': '1.490 €', '300': '2.490 €'
    };
    const sizeValue = (d.size === 'custom')
      ? ((d.size_custom || '').trim() || 'Eigenes Wunschmaß')
      : (sizeLabels[d.size] ? (sizeLabels[d.size] + (sizePrices[d.size] ? ' · ab ' + sizePrices[d.size] : '')) : '-');
    parts.push(reviewRow('Wunsch-Größe', sizeValue, 'groesse'));

    const rsValue = (d.rueckseite === 'freitext')
      ? ((d.rueckseite_text || '').trim() || 'Eigener Wunsch')
      : 'Standard: drei 4-mm-Löcher, je 5 cm, auf einer Linie';
    parts.push(reviewRow('Rückseite', rsValue, 'rueckseite'));

    const body = root.querySelector('[data-review-body]');
    if (body) {
      body.innerHTML = parts.join('');
      injectReviewPreview(body);
    }

    root.querySelectorAll('[data-review-edit]').forEach(btn => {
      btn.addEventListener('click', () => showStep(btn.dataset.reviewEdit));
    });

    var _lwTotalStr = fmtPrice(calcPriceCents());
    root.querySelectorAll('[data-total-price]').forEach(function (el) {
      el.textContent = _lwTotalStr;
    });
  }

  function reviewRow(label, value, editStep) {
    return '<div class="lw-review__row">' +
      '<span class="lw-review__label">' + label + '</span>' +
      '<div class="lw-review__val">' +
        '<div class="lw-review__main">' + escapeHtml(value) + '</div>' +
        '<button class="lw-review__edit" data-review-edit="' + editStep + '">Anpassen</button>' +
      '</div>' +
    '</div>';
  }

  function escapeHtml(s) {
    if (!s) return '';
    return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]);
  }
  function escapeAttr(s) { return escapeHtml(s); }

  // ---------- Cloudinary Upload ----------
  function uploadToCloudinary(file) {
    const cloud = DATA.cloudinary || {};
    if (!cloud.cloud_name || !cloud.upload_preset) {
      showToast('Upload-Konfiguration fehlt - bitte Support kontaktieren');
      console.error('[lw-funnel-xxl] Cloudinary-Config fehlt:', cloud);
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      showToast('Datei ist zu groß (max 10 MB)');
      return;
    }
    const allowed = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'application/pdf'];
    if (!allowed.includes(file.type)) {
      showToast('Nur JPG, PNG, WebP oder PDF erlaubt');
      return;
    }

    setUploadState('uploading');
    const fill = root.querySelector('[data-upload-fill]');
    const pct = root.querySelector('[data-upload-pct]');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', cloud.upload_preset);
    formData.append('folder', 'lampenwerk24/references/xxl-logo/' + new Date().toISOString().slice(0, 7));

    const xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + cloud.cloud_name + '/image/upload');

    xhr.upload.addEventListener('progress', e => {
      if (e.lengthComputable) {
        const ratio = e.loaded / e.total;
        if (fill) fill.style.transform = 'scaleX(' + ratio + ')';
        if (pct) pct.textContent = Math.round(ratio * 100) + '%';
      }
    });

    xhr.addEventListener('load', () => {
      console.log('[lw-funnel-xxl] Cloudinary-Response Status:', xhr.status);
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const response = JSON.parse(xhr.responseText);
          if (!response.secure_url) {
            console.error('[lw-funnel-xxl] secure_url fehlt in Response:', response);
            uploadFailed('Upload-Antwort fehlt URL - siehe Console');
            return;
          }
          state.set('upload', {
            name: file.name,
            sizeMB: (file.size / 1024 / 1024).toFixed(1).replace('.', ','),
            url: response.secure_url,
            public_id: response.public_id,
            original_filename: response.original_filename
          });
          state.set('upload_timestamp', new Date().toISOString());
          state.set('preview', null);  // neues Logo -> alte Vorschau verwerfen
          setUploadState('success');
          restoreUI();
          updateActionBar();
        } catch (e) {
          console.error('[lw-funnel-xxl] JSON-Parse-Fehler:', e, xhr.responseText);
          uploadFailed('Upload-Antwort konnte nicht gelesen werden');
        }
      } else {
        let errMsg = 'Upload fehlgeschlagen (HTTP ' + xhr.status + ')';
        try {
          const errData = JSON.parse(xhr.responseText);
          if (errData.error && errData.error.message) {
            errMsg = 'Cloudinary: ' + errData.error.message;
            console.error('[lw-funnel-xxl] Cloudinary Error:', errData.error);
          }
        } catch (e) {}
        uploadFailed(errMsg);
      }
    });

    xhr.addEventListener('error', (e) => {
      console.error('[lw-funnel-xxl] Upload Network Error:', e);
      uploadFailed('Netzwerk-Fehler - siehe Console');
    });
    xhr.addEventListener('abort', () => uploadFailed('Upload abgebrochen'));

    xhr.send(formData);
  }

  function uploadFailed(msg) {
    showToast(msg);
    setUploadState('empty');
  }

  function setUploadState(newState) {
    root.querySelectorAll('[data-upload-state]').forEach(el => {
      el.style.display = el.dataset.uploadState === newState ? '' : 'none';
    });
  }

  // ---------- Cart Submit ----------
  function submitCart() {
    const d = state.load();
    const mainVariant = findVariantForCart();
    if (!mainVariant) {
      showToast('Dieses Muster ist leider nicht verfügbar');
      return;
    }

    const sessionId = 'lw-' + Math.random().toString(36).slice(2, 10) + '-' + Date.now().toString(36);
    const shapeLabels = { eckig: 'Eckig', rund: 'Rund', kontur: 'Nur Kontur' };
    const einsatzLabels = { indoor: 'Drinnen', outdoor: 'Draußen' };
    const lichtLabels = { kaltweiss: 'Kaltweiß · mit Fernbedienung', farbig: 'Farbig / RGB · mit Fernbedienung' };
    const sizeLabels = {
      '40': '40 cm', '50': '50 cm', '60': '60 cm', '70': '70 cm', '80': '80 cm',
      '90': '90 cm', '100': '100 cm', '200': '200 cm', '300': '300 cm und mehr'
    };
    const sizePrices = {
      '40': '199 €', '50': '249 €', '60': '299 €', '70': '369 €', '80': '449 €',
      '90': '549 €', '100': '699 €', '200': '1.490 €', '300': '2.490 €'
    };
    const sizeValue = (d.size === 'custom')
      ? ((d.size_custom || '').trim() || 'Eigenes Wunschmaß')
      : (sizeLabels[d.size] ? (sizeLabels[d.size] + (sizePrices[d.size] ? ' (ab ' + sizePrices[d.size] + ')' : '')) : (d.size || '-'));
    const rueckseiteValue = (d.rueckseite === 'freitext')
      ? ((d.rueckseite_text || '').trim() || 'Eigener Wunsch')
      : 'Standard: drei 4-mm-Löcher, je 5 cm, auf einer Linie';

    const previewUrl = (d.preview && d.preview.status === 'done' && d.preview.url) ? d.preview.url : '';

    const props = {
      // Sichtbare Properties (Kunde + Production sehen sie)
      'Form': shapeLabels[d.shape] || d.shape || '-',
      'Einsatzort': einsatzLabels[d.einsatz] || d.einsatz || '-',
      'Lichtfarbe': lichtLabels[d.lichtfarbe] || d.lichtfarbe || '-',
      'Wunsch-Größe': sizeValue,
      'Rückseite': rueckseiteValue,
      '_Logo-Vorschau': pngUrlFor(d.upload.url),
      // Hidden Admin
      '_Vorschau-Modus': d.invert ? 'inverted' : 'standard',
      '_Funnel-Session': sessionId,
      '_Funnel-Version': FUNNEL_VERSION,
      '_Funnel-Typ': 'xxl-logo',
      '_Upload-Zustimmung': 'true'
    };
    if (previewUrl) {
      props['_Lampen-Vorschau'] = previewUrl;
    }
    // Bei .ai/.eps/.pdf zeigt "Logo-Vorschau" die PNG-Fassung - die Originaldatei
    // kommt versteckt dazu, damit in der Produktion die echte Vorlage vorliegt.
    if (d.upload && pngUrlFor(d.upload.url) !== d.upload.url) {
      props['_Logo-Datei'] = d.upload.url;
    }

    const items = [{ id: mainVariant.id, quantity: 1, properties: props }];

    const nextBtn = root.querySelector('[data-action="next"]');
    const nextLabel = root.querySelector('[data-next-label]');
    if (nextBtn) nextBtn.disabled = true;
    if (nextLabel) nextLabel.textContent = 'Wird hinzugefügt ...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(resp => {
      if (!resp.ok) return resp.json().then(err => { throw err; });
      return resp.json();
    })
    .then(() => {
      state.clear();
      sessionStorage.setItem('lw_open_cart_drawer', '1');
      document.body.removeAttribute('data-funnel-active');
      var _lwf = document.getElementById('lw-funnel');
      if (_lwf) _lwf.style.display = 'none';
      window.location.href = '/';
    })
    .catch(err => {
      console.error('[lw-funnel-xxl] Cart-Add Fehler:', err);
      const msg = (err && err.description) || 'Konnte nicht in den Warenkorb - bitte erneut versuchen';
      showToast(msg);
      if (nextBtn) nextBtn.disabled = false;
      if (nextLabel) nextLabel.textContent = 'Muster sichern - 50 €';
    });
  }

  // ---------- Toast ----------
  let toastTimer = null;
  function showToast(msg) {
    const t = document.querySelector('.lw-toast');
    if (!t) { console.warn('[lw-funnel-xxl] Toast-Element nicht gefunden:', msg); return; }
    t.textContent = msg;
    t.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2800);
  }

  // ---------- Events ----------
  function bind() {
    document.querySelectorAll('[data-action="next"]').forEach(el => el.addEventListener('click', goNext));
    document.querySelectorAll('[data-action="back"]').forEach(el => el.addEventListener('click', goBack));

    const closeBtn = root.querySelector('[data-action="close"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        if (confirm('Funnel verlassen? Deine Eingaben gehen verloren.')) {
          state.clear();
          window.location.href = '/';
        }
      });
    }

    // Form
    root.querySelectorAll('.lw-shape').forEach(el => {
      el.addEventListener('click', () => {
        state.set('shape', el.dataset.shape);
        state.set('preview', null);  // Form geaendert -> Vorschau verwerfen
        restoreUI();
        updateActionBar();
      });
    });

    // Einsatzort
    root.querySelectorAll('[data-einsatz]').forEach(el => {
      el.addEventListener('click', () => {
        state.set('einsatz', el.dataset.einsatz);
        restoreUI();
        updateActionBar();
      });
    });

    // Upload
    const dropzone = root.querySelector('[data-upload-zone]');
    const fileInput = root.querySelector('[data-upload-input]');
    if (dropzone && fileInput) {
      dropzone.addEventListener('click', () => fileInput.click());
      fileInput.addEventListener('change', e => {
        if (e.target.files.length) uploadToCloudinary(e.target.files[0]);
      });
      ['dragenter','dragover'].forEach(ev =>
        dropzone.addEventListener(ev, e => { e.preventDefault(); dropzone.classList.add('is-drag'); }));
      ['dragleave','drop'].forEach(ev =>
        dropzone.addEventListener(ev, e => { e.preventDefault(); dropzone.classList.remove('is-drag'); }));
      dropzone.addEventListener('drop', e => {
        if (e.dataTransfer.files.length) uploadToCloudinary(e.dataTransfer.files[0]);
      });
    }

    document.addEventListener('click', e => {
      if (e.target.closest('[data-action="replace-upload"]')) {
        state.set('upload', null);
        state.set('upload_consent', false);
        state.set('preview', null);
        restoreUI();
        updateActionBar();
      }
    });

    const consentBox = root.querySelector('[data-upload-consent]');
    if (consentBox) {
      consentBox.addEventListener('change', e => {
        e.stopPropagation();
        state.set('upload_consent', consentBox.checked);
        updateActionBar();
      });
    }

    // Invert-Auswahl
    root.querySelectorAll('[data-invert]').forEach(el => {
      el.addEventListener('click', () => {
        const inv = el.dataset.invert === 'invertiert';
        state.set('invert', inv);
        state.set('preview', null);  // Modus geaendert -> Vorschau verwerfen
        restoreUI();
      });
    });

    // Lichtfarbe
    root.querySelectorAll('[data-lichtfarbe]').forEach(el => {
      el.addEventListener('click', () => {
        state.set('lichtfarbe', el.dataset.lichtfarbe);
        restoreUI();
        updateActionBar();
      });
    });

    // Groesse (Wunsch-Groesse)
    root.querySelectorAll('.lw-size').forEach(el => {
      el.addEventListener('click', () => {
        state.set('size', el.dataset.size);
        restoreUI();
        updateActionBar();
      });
    });

    // Groesse-Freitext (Wunschmass)
    const sizeText = root.querySelector('[data-size-text]');
    if (sizeText) {
      sizeText.addEventListener('input', () => {
        state.set('size_custom', sizeText.value);
        updateActionBar();
      });
    }

    // Rueckseite-Auswahl
    root.querySelectorAll('[data-rueckseite]').forEach(el => {
      el.addEventListener('click', () => {
        state.set('rueckseite', el.dataset.rueckseite);
        restoreUI();
        updateActionBar();
      });
    });

    // Rueckseite-Freitext
    const rsText = root.querySelector('[data-rueckseite-text]');
    if (rsText) {
      rsText.addEventListener('input', () => {
        state.set('rueckseite_text', rsText.value);
        updateActionBar();
      });
    }

    window.addEventListener('popstate', () => {
      const s = getStepFromURL() || STEPS[0];
      showStep(s);
    });
  }

  // ---------- Shopify-Preview-Mode erkennen ----------
  if (location.search.indexOf('preview_theme_id') > -1 || window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('lw-preview-mode');
  }

  // ---------- Action-Bar an Body anhaengen ----------
  (function rescueActionBar() {
    const actionbar = document.querySelector('.lw-actionbar');
    const toast = document.querySelector('.lw-toast');
    if (actionbar && actionbar.parentElement !== document.body) {
      document.body.appendChild(actionbar);
    }
    if (toast && toast.parentElement !== document.body) {
      document.body.appendChild(toast);
    }
  })();

  // ---------- Init ----------
  ensureDefaults();
  try { window.scrollTo({ top: 0, behavior: 'instant' }); document.documentElement.scrollTop = 0; document.body.scrollTop = 0; } catch(_) {}
  bind();
  showStep(state.get('step') || STEPS[0]);

  // ---------- Debug-Hooks ----------
  window.__lwFunnelXxl = {
    state, DATA,
    showStep, goNext, goBack,
    uploadToCloudinary, submitCart, startPreview,
    calcPriceCents, findVariantForCart
  };
})();